import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ChatPage from './components/ChatPage';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Chat público: registro por teléfono + conversación */}
        <Route path="/" element={<ChatPage />} />
        {/* Ruta "oculta" de acceso del administrador (no está enlazada en ningún lado) */}
        <Route path="/login" element={<AdminLogin />} />
        {/* Panel del administrador (protegido) */}
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
